//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { queryProjectTypeCodeNumber, queryProjectStatusNumber, queryProjStatusNumber, queryProjectGroupByDeptCode } from '@/api/pm/project';

export default {
	data() {
		return {
			allProjectOverview: [{number:0,projTypeName:"无数据"}], //所有的项目类型数量总览
			projectStatusOverview: [{number:0,status:"无数据"}], //所有项目的审批状态及其数量预览
			projStatusOverview: [{number:0,projStatus:"无数据"}], //所有项目的状态及其数量预览
			projectGroupByDeptCode: [{number:0,respDeptName:"无数据"}], //不同部门项目数量及其项目类型
		}
	},
	created() {

	},
	computed: {},
	mounted: function () {
		this.loadProjectTypeCodeNumber('');
		this.loadQueryProjectStatusNumber();
		this.loadQueryProjStatusNumber();
		this.loadProjectGroupByDeptCode('');
	},
	methods: {
		// 返回
		goback() {
			// 返回工作台
			this.$router.push({
				name: 'workbench'
			});
		},
		//根据条件获取每种项目类型的项目数量
		loadProjectTypeCodeNumber(value) {
			var condition = { 'respDeptCode': value };
			queryProjectTypeCodeNumber(condition).then(response => {
        if(response.length>0){
          this.allProjectOverview =response;
        }
				// 数据赋值
				// for (let i = 0; i < response.length; i++) {
				// 	this.allProjectOverview.push(response[i]);
				// }
			});
		},
		//加载每种项目状态及其数量
		loadQueryProjectStatusNumber() {
			queryProjectStatusNumber().then(response => {
        if(response.length>0){
          this.projectStatusOverview =response;
        }
        // // 数据赋值
				// for (let i = 0; i < response.length; i++) {
				// 	this.projectStatusOverview.push(response[i]);
				// }
			});
		},
		loadQueryProjStatusNumber() {
			queryProjStatusNumber().then(response => {
        if(response.length>0){
          this.projStatusOverview =response;
        }
        // 数据赋值
				// for (let i = 0; i < response.length; i++) {
				// 	this.projStatusOverview.push(response[i]);
				// }
			});
		},
		//不同部门的项目数量
		loadProjectGroupByDeptCode(value) {
			var condition = { 'respDeptCode': value };
			queryProjectGroupByDeptCode(condition).then(response => {
        if(response.length>0){
          this.projectGroupByDeptCode =response;
        }
        // //数据赋值
				// for (let i = 0; i < response.length; i++) {
				// 	this.projectGroupByDeptCode.push(response[i]);
				// }
			});
		},
		//进入列表信息
		loadListData(projTypeCode, status, projStatus, respDeptCode) {
			debugger
			// 参数一：项目类型
			// 参数二：状态
			// 参数三：部门编码
			if (projTypeCode == '005') {
				//项目售前类
				this.$router.push({
					name: '售前人员',
					params: {
						gobackName: '立项总览',
						projTypeCode: projTypeCode,
						respDeptCode: respDeptCode
					}
				});
			} else {
				this.$router.push({
					name: '立项列表',
					params: {
						gobackName: '立项总览',
						projTypeCode: projTypeCode,
						status: status,
						projStatus: projStatus,
						respDeptCode: respDeptCode
					}
				});
			}

		}
	}
}



// WEBPACK FOOTER //
// ./src/view/pm/project/projectOverview.vue